
import React, { useEffect, useState } from "react";
import Content from "../../../components/Contents/Content";
import { Doughnut } from "react-chartjs-2";
import { Link, useNavigate, useLocation } from "react-router-dom";
import {
  GetBasketService,
  BasketPurchaseList,
  GetUserData
} from "../../../Services/UserService/User";
import { basicsettinglist } from "../../../Services/Admin/Admin";
import { loadScript } from "../../../../Utils/Razorpayment";
import Loader from "../../../../Utils/Loader";
import Kyc from "../Profile/Kyc";
import ReusableModal from "../../../components/Models/ReusableModal";
import showCustomAlert from "../../../Extracomponents/CustomAlert/CustomAlert";
import { AddToCartBasket, ShowBasketCartList } from "../../../Services/UserService/clientService";

function Basket() {


  const location = useLocation();
  const newActiveTab = location?.state?.activeTab || {};



  const [activeTab, setActiveTab] = useState(() =>
    newActiveTab === "basket" ? "subscribedbasket" : "allbasket"
  );


  const [basketdata, setBasketdata] = useState([]);

  const [purchasedata, setPurchasedata] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const token = localStorage.getItem("token");
  const userid = localStorage.getItem("id");

  const navigate = useNavigate();

  const [onlinePaymentStatus, setOnlinePaymentStatus] = useState();
  const [offlinePaymentStatus, setOfflinePaymentStatus] = useState();
  const [userdata, setUserdata] = useState([]);

  const [kycStatus, setKycStatus] = useState("");
  const [viewmodel2, setViewModel2] = useState(false);
  const [cartItems, setCartItems] = useState(0);
  const [kyckey, setKyckey] = useState([])




  useEffect(() => {
    if (activeTab === "allbasket") {
      getbasketdata();
    } else if (activeTab === "subscribedbasket") {
      getbasketpurchasedata();
    }
  }, [activeTab, isLoading]);




  useEffect(() => {
    getkeybydata();
    fetchUserData();
    basketList();
  }, []);



  const basketList = async () => {
    try {
      const response = await ShowBasketCartList(userid, token);
      if (response.status) {
        setCartItems(response.data.length);
      } else {
        setCartItems([])
      }
    } catch (err) {
      console.log('Error fetching cart:', err);
    }
  };



  const fetchUserData = async () => {
    try {
      const userData = await GetUserData(userid, token);
      if (userData && userData.data) {
        setUserdata(userData.data);
      }
    } catch (error) {
      showCustomAlert("error", "Failed to load user data. Please refresh and try again.");
    }
  };



  const handleShowModal = (item) => {

    if (item?.isSubscribed === true && item?.isActive === false) {
      handelRedirect(item);
    } else if (kycStatus == 1 && (userdata?.kyc_verification == 0 || userdata?.kyc_verification == 2)) {
      setViewModel2(true);
      setKyckey(item._id)
    } else {
      handelRedirect(item);
    }
  };




  const getkeybydata = async () => {
    try {
      const response = await basicsettinglist();
      if (response.status) {
        setOnlinePaymentStatus(response.data[0].paymentstatus);
        setOfflinePaymentStatus(response.data[0].officepaymenystatus);
        setKycStatus(response?.data[0].kyc);
      }
    } catch (error) {
      console.error("Error fetching coupons:", error);
    }
  };




  const getbasketdata = async () => {
    try {
      const data = { clientid: userid };
      const response = await GetBasketService(data, token);
      if (response.status) {
        setBasketdata(response.data);
      }
    } catch (error) {
      console.log("error", error);
    }
    setIsLoading(false);
  };




  const getbasketpurchasedata = async () => {
    try {
      const data = { clientid: userid };
      const response = await BasketPurchaseList(data, token);
      if (response.status) {
        setPurchasedata(response.data);
      }
    } catch (error) {
      console.log("error", error);
    }
    setIsLoading(false);
  };



  const stripHtmlTags = (input) => {
    if (!input) return "";
    return input.replace(/<\/?[^>]+(>|$)/g, "");
  };




  const handelRedirect = (item) => {
    if (item?.isSubscribed && !item?.isActive && (onlinePaymentStatus || offlinePaymentStatus)) {
      navigate("/user/payment", { state: { item } });
    } else {
      navigate("/user/payment", { state: { item } });
    }
  };




  const addToBasketCart = async (item) => {
    try {
      const data = {
        basket_id: item?._id,
        client_id: userid
      };

      const response = await AddToCartBasket(data, token);
      if (response.status) {
        showCustomAlert("success", response.message || "Item added successfully!");
        basketList()
      } else {
        showCustomAlert("error", response.message || "Failed to add item.");
      }
    } catch (error) {
      showCustomAlert("error", "Something went wrong, please try again.");
    }
  };




  return (
    <Content
      Page_title="Basket"
      button_title="Add Basket"
      backbutton_title="back"
      button_status={false}
      backbutton_status={false}
      cart_count={cartItems}
      cart_button="Cart"
      cartroute="/user/basketcart"
    >
      <ul className="nav nav-pills mb-3 justify-content-center border-bottom mb-">
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === "allbasket" ? "active btn-primary" : ""}`}
            onClick={() => setActiveTab("allbasket")}
          >
            All Basket
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === "subscribedbasket" ? "active btn-primary" : ""}`}
            onClick={() => setActiveTab("subscribedbasket")}
          >
            Subscribed Basket
          </button>
        </li>
      </ul>
      <div className="tab-content basket-card">
        {activeTab === "allbasket" &&
          (isLoading ? (
            <Loader />
          ) : basketdata?.length > 0 ? (
            <div className="row">
              {basketdata?.map((item) => (
                <div className="col-md-12 col-lg-6 mb-4" key={item?.id}>
                  <div
                    className="card basket-card radius-10 overflow-hidden shadow"
                    style={{ minHeight: "253px", display: "flex", flexDirection: "column", justifyContent: "space-between" }}

                  >
                    <div className="card-body pb-0">
                      <div className="d-flex ">
                        <img
                          src={item.image}
                          alt="Basket"
                          style={{ width: "70px", height: "70px" }}
                          className=" img-fluid mb-3"
                        />
                        <div className="mb-0 ms-3 ">
                          <div className="d-flex justify-content-between align-items-center">
                            <h4 className="mb-0">
                              {item?.title} ({item?.themename})
                            </h4>
                            {item?.isSubscribed && item.isActive ? (
                              <span
                                className="badge bg-success"
                                style={{ fontSize: "12px" }}

                              >
                                Subscribed
                              </span>
                            ) :
                              item?.isSubscribed && !item.isActive && (
                                <span
                                  className="badge bg-danger"
                                  style={{ fontSize: "12px" }}

                                >
                                  Expired
                                </span>
                              )}
                          </div>
                          <p className="basket-short-description mb-1">
                            {stripHtmlTags(item?.description || "")}
                          </p>
                          <div className="text-muted fs-6">
                            {" "}
                            Since Launch
                            <span>
                              <b className="">: {item?.cagr_live}%</b>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <hr />
                    <div className="card-body pt-0  ">
                      <ul className="list-group list-group-flush list d-flex flex-row justify-content-between mb-3">
                        <li className="list-group-item border-bottom-0 border-right">
                          <div className="text-muted fs-6">
                            Minimum Investment
                          </div>
                          <b className="">{item?.mininvamount}</b>
                        </li>
                        <li className="list-group-item border-bottom-0">
                          <div className="text-muted fs-6">Volatility</div>
                          <b className="">{item?.type}</b>
                        </li>
                        <li className="list-group-item border-bottom-0">
                          {item?.isSubscribed && item?.isActive ? (
                            <button
                              // state={{ item }}
                              className="btn btn-sm btn-primary"
                              onClick={() => navigate("/user/basketdetail", { state: { item } })}
                            >
                              View Details
                            </button>

                          ) : item?.isSubscribed && !item?.isActive ? (
                            <div className="d-flex flex-column gap-1">
                              <button
                                // state={{ item }}
                                className="btn btn-sm btn-primary "
                                onClick={() => navigate("/user/basketdetail", { state: { item } })}
                                style={{ width: '163px' }}
                              >
                                View Details
                              </button>
                              <button
                                state={{ item }}
                                className="btn btn-sm btn-primary "
                                onClick={() => handleShowModal(item)}
                                style={{ width: '163px' }}
                              >
                                Subscribe Now
                              </button>
                              <button className="btn btn-sm btn-primary " onClick={(e) => addToBasketCart(item)}
                                style={{ width: '163px' }}>
                                Add to Cart
                              </button>
                            </div>
                          ) : (
                            <>
                              <button
                                state={{ item }}
                                className="btn btn-sm btn-primary w-100"
                                onClick={() => handleShowModal(item)}
                              >
                                Subscribe Now
                              </button>
                              <button className="btn btn-sm btn-primary w-100 mt-1" onClick={(e) => addToBasketCart(item)}>
                                Add to Cart
                              </button>
                            </>
                          )}

                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center mt-4">
              <img
                src="/assets/images/nodata.png"
                alt="No Records Found"
              />
            </div>
          ))}
        {activeTab === "subscribedbasket" &&
          (isLoading ? (
            <Loader />
          ) : purchasedata?.length > 0 ? (
            <div className="row">
              {purchasedata?.map((item) => (
                <div className="col-md-6 col-lg-6 mb-3" key={item?.id}>
                  <div className="card radius-10 overflow-hidden shadow ">
                    <div className="card-body pb-0">
                      <div className="d-flex ">
                        <img
                          src={item?.image}
                          alt="Basket"
                          style={{ width: "70px", height: "70px" }}
                          className=" img-fluid mb-3"
                        />
                        <div className="mb-0 ms-3 ">
                          <h4>
                            {item?.title} ({item?.themename})
                            {item?.isSubscribed && !item.isActive && (
                              <span
                                className="badge bg-danger"
                                style={{ fontSize: "12px" }}

                              >
                                Expired
                              </span>
                            )}
                          </h4>
                          <p className="basket-short-description mb-1">
                            {stripHtmlTags(item?.description || "")}
                          </p>
                          <div className="text-muted fs-6">
                            {" "}
                            Since Launch
                            <span>
                              <b className="">: {item?.cagr_live}%</b>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <hr />
                    <div className="card-body pt-0  ">
                      <ul className="list-group list-group-flush list d-flex flex-row justify-content-between mb-3">
                        <li className="list-group-item border-bottom-0 border-right">
                          <div className="text-muted fs-6">
                            Minimum Investment
                          </div>
                          <b className="">{item?.mininvamount}</b>
                        </li>
                        <li className="list-group-item border-bottom-0">
                          <div className="text-muted fs-6">Volatility</div>
                          <b className="">{item?.type}</b>
                        </li>
                        <li className="list-group-item border-bottom-0">
                          <Link
                            to="/user/basketdetail"
                            state={{ item }}
                            className="btn btn-sm btn-primary w-100"
                          >
                            View Details
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center mt-4">
              <img
                src="/assets/images/nodata.png"
                alt="No Records Found"
              />
            </div>
          ))}

      </div>
      <ReusableModal
        show={viewmodel2}
        onClose={() => setViewModel2(false)}
        title={<>KYC</>}
        body={
          <Kyc
            onSuccess={() => {
              setViewModel2(false);
            }}
            type="payment"
            kyckey={kyckey}
          />
        }
        size="lg"
      />
    </Content>
  );
}

export default Basket;